import React, { useState } from "react";
import AlgoBullsWelcome from "./AlgoBullsWelcome/AlgoBullsWelcome";
import KeyFeatures from "./KeyFeatures/KeyFeatures";
import Howtostart from "./howtostart/HowtoAlgoBulls";
import AlgoBullsDownload from "./AlgoBullsDownload/AlgoBullsDownload" 
import { Image } from "react-bootstrap/Image";
import CallTrackApi from "../Activity_Track/CallTrackApi";
function AlgoBulls() {
  window.scrollTo(0, 0)
  const [welcomeData, setWelcomeSection] = useState(
    {
      title: "AlgoBulls",
      content1:
        'Why spend years attempting to master the complexity of capital markets when AlgoBulls unique AI-driven trading algorithmic platform unlocks the potential of capital market investment. Market players can pick from a diverse set of smart, AI-driven strategies developed at the junction of cutting-edge technology and extensive trading knowledge with AlgoBulls.',
      content2:
        "They provide a distinct range of trading Algos for both novices and experts that perform all transactions, allowing anybody from any part of the world to profit from the capital market. AlgoBulls offers a powerful, tech-driven, and AI-led trading platform where both traders and developers may design their own trading strategies and even monetize their skills all under one roof",
    },
    []
  );
  
  CallTrackApi("Algobulls",window.location.href);

  return (
    <>
      <AlgoBullsWelcome data={welcomeData} />
          <KeyFeatures />
          <Howtostart />
          <AlgoBullsDownload />
          
    </>
  );
}
export default AlgoBulls;

